/* eslint-disable import/prefer-default-export */
import {
  getQAForBroadband,
  getQAForFixedline,
  getAreaCode,
  getNLE,
  saveAscertain,
} from '../../integration/ascertain.api';
import useLocalStorage from '../../hooks/useLocalStorage';
import getCarts from '../../integration/cart.api';
import { getCartInfo } from '../eir-cart/cart.util';

const localStore = useLocalStorage();

export const onLoadCurrentService = async ({ graphql, localStorage }) => {
  try {
    if (localStorage.hasValue('prospectuuid')) {
      const { getCart: cart } = await getCarts({
        graphql,
        variables: { reference: localStorage.getLocalStorage('prospectuuid') },
      });

      const cartInfo = getCartInfo(cart);

      return { cart, cartInfo };
    }
  } catch (error) {
    console.error(error);
    return { error };
  }
};
export const onGetQAForBB = async ({ graphql, bbUAN }) => {
  try {
    const variables = {
      uan: bbUAN,
    };
    const result = await getQAForBroadband({ graphql, variables });
    return { result, errors: null };
  } catch (err) {
    console.error(err);
    return { result: null, errors: err.message };
  }
};

export const onGetQAForFixedline = async ({ graphql, uan, fixedLineNumber }) => {
  try {
    const variables = {
      fixedLineNumber,
      uan,
    };
    const result = await getQAForFixedline({ graphql, variables });
    return { result, errors: null };
  } catch (err) {
    console.error(err);
    return { result: null, errors: err.message };
  }
};

export const onGetNLE = async ({ graphql }) => {
  try {
    let prequalId;
    if (localStore.getLocalStorage('PREQUAL_RESULT')) {
      prequalId = JSON.parse(localStore.getLocalStorage('PREQUAL_RESULT')).prequalId;
    }
    const variables = {
      nleId: JSON.parse(prequalId),
    };
    const result = await getNLE({ graphql, variables });
    return { result, errors: null };
  } catch (err) {
    console.error(err);
    return { result: null, errors: err.message };
  }
};

export const onGetSelectedOfferTechnology = async ({ graphql }) => {
  // get the selected offer value from prospect.
  const { getCart: cartData } = await getCarts({
    graphql,
    variables: { reference: localStore.getLocalStorage('PROSPECTUUID') },
  });
  return {
    broadbandTechnolgy: cartData.offers.filter(
      offer => offer.baseOffer.serviceGroup === 'DUALPLAY'
    )[0].baseOffer?.broadbandTechnology,
    offerId: cartData.offers.filter(offer => offer.baseOffer.serviceGroup === 'DUALPLAY')[0].id,
  };
};

export const onSaveAscertain = async ({ graphql, offerId, ascertainRequest }) => {
  try {
    const variables = {
      reference: localStore.getLocalStorage('PROSPECTUUID'),
      offerId,
      ascertainRequest,
    };
    const result = await saveAscertain({ graphql, variables });
    localStore.setLocalStorage('APPOINTMENT_TYPE', result?.saveAscertainDetails?.appointmentType);
    return { result, errors: null };
  } catch (err) {
    console.error(err);
    return { result: null, errors: err.message };
  }
};

export const onGetAreaCode = async ({ graphql }) => {
  try {
    const result = await getAreaCode({ graphql });
    return { result, errors: null };
  } catch (err) {
    console.error(err);
    return { result: null, errors: err.message };
  }
};

export const getreferenceLabel = data => {
  let result = {
    labelName: '',
    labelDescription: '',
  };
  if (data.provider === 'VIRGIN MEDIA') {
    result = { labelName: 'Account Number', labelDescription: '' };
  } else if (data.provider === 'SKY') {
    result = {
      labelName: 'Sky Talk Account Number ',
      labelDescription:
        'Your Sky Talk Account Number can be found on your bill and may be a 10 to 12 digit number. It may also begin with PO or SV',
    };
  } else if (data.provider === 'VODAFONE') {
    result = {
      labelName: 'Customer Account Number ',
      labelDescription:
        'Your Customer Account Number can be found on your bill and will be 10 digits long.',
    };
  } else if (data.provider === 'PURE' || data.provider === 'IFA') {
    result = {
      labelName: 'Landline/VOBB UAN ',
      labelDescription:
        'Your landline/VOBB UAN can be found on your bill and will be 8 digits long. ',
    };
  } else if (data.provider === 'DIGIWEB') {
    result = {
      labelName: 'Customer Account Number ',
      labelDescription: 'You will find these details on your bill. ',
    };
  } else if (data.provider === 'IMAGINE' || data.provider === 'OTHER') {
    result = {
      labelName: 'Customer Reference / Account Number ',
      labelDescription: 'You will find these details on your bill. ',
    };
  }
  return result;
};
